import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatLegacyChipInputEvent as MatChipInputEvent } from '@angular/material/legacy-chips';
import { BaseComponent } from '@app/shared/components/base/base.component';
import { SmpUtils } from '@app/core/helpers/utilities';

@Component({
    selector: 'email-chips',
    templateUrl: './email-chips.component.html',
    styleUrls: ['./email-chips.component.scss']
})
export class EmailChipsComponent extends BaseComponent implements OnInit {

    @Input()
    public label?: string;

    @Input()
    public required?: boolean;

    private _addresses: string;

    @Input()
    set addresses(addresses: string) {
        this._addresses = addresses;
        this.ngOnInit();
    }

    @Output()
    public addressesChange = new EventEmitter<string>();

    @Output()
    public validated = new EventEmitter<boolean>();

    public emailAddresses: { value: string, valid: boolean }[];

    public requiredMissing: boolean;

    get onlyContainsValidEmailAddresses(): boolean {
        return !this.emailAddresses.find(address => !address.valid);
    }

    constructor() {
        super();
        this._idPrefix = 'email-chips.';
    }

    public ngOnInit() {
        this.emailAddresses = this.convertStringToValidatedEmailArray(this._addresses);
    }

    private convertStringToValidatedEmailArray(emailsAsStringValue: string): { value: string, valid: boolean }[] {
        return emailsAsStringValue ? emailsAsStringValue.split(',')
            .map(splitValue => {
                return {value: splitValue, valid: SmpUtils.validateAsEmail(splitValue) };
            }) : [];
    }

    public add(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;

        if (value && value.trim()) {
            this.emailAddresses.push({
                value: value,
                valid: SmpUtils.validateAsEmail(value.trim())
            });

            this.onAddressesChange();
        }

        if (input) {
            input.value = '';
        }
    }

    public remove(idx: number): void {
        if (idx > -1) {
            this.emailAddresses.splice(idx, 1);
            this.onAddressesChange();
        }
    }

    private onAddressesChange(): void {
        if (this.onlyContainsValidEmailAddresses) {
            this._addresses = this.emailAddresses.map(a => a.value).join();
            this.addressesChange.emit(this._addresses);
        }

        this.validate();
    }

    public validate(): void {
        this.requiredMissing = this.required && this.emailAddresses.length === 0;
        this.validated.emit(this.onlyContainsValidEmailAddresses && !this.requiredMissing);
    }
}
